export const ROOT_PATH = "/";
export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;
export const DASHBOARD_PATH = `${ROOT_PATH}dashboard`;

export const CHAT_PAGE_PATH = `${ROOT_PATH}chat`;

// error
export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;

// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// site config
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// book
export const BOOK_LIST_PATH = `${ROOT_PATH}book-list`;
export const ADD_BOOK_PATH = `${ROOT_PATH}add-book`;
export const EDIT_BOOK_PATH = `${ROOT_PATH}edit-book`;

// bookOrder
export const BOOKORDER_LIST_PATH = `${ROOT_PATH}bookOrder-list`;
export const ADD_BOOKORDER_PATH = `${ROOT_PATH}add-bookOrder`;
export const EDIT_BOOKORDER_PATH = `${ROOT_PATH}edit-bookOrder`;
// gym

export const GYM_LIST_PATH = `${ROOT_PATH}gym-list`;
export const ADD_GYM_PATH = `${ROOT_PATH}add-gym`;
export const EDIT_GYM_PATH = `${ROOT_PATH}edit-gym`;
// invoice

export const INVOICE_LIST_PATH = `${ROOT_PATH}invoice-list`;
export const ADD_INVOICE_PATH = `${ROOT_PATH}add-invoice`;
export const EDIT_INVOICE_PATH = `${ROOT_PATH}edit-invoice`;
// gymPayment

export const GYMPAYMENT_LIST_PATH = `${ROOT_PATH}gymPayment-list`;
export const ADD_GYMPAYMENT_PATH = `${ROOT_PATH}add-gymPayment`;
export const EDIT_GYMPAYMENT_PATH = `${ROOT_PATH}edit-gymPayment`;
// device

export const DEVICE_LIST_PATH = `${ROOT_PATH}device-list`;
export const ADD_DEVICE_PATH = `${ROOT_PATH}add-device`;
export const EDIT_DEVICE_PATH = `${ROOT_PATH}edit-device`;
// smsRecords

export const SMSRECORDS_LIST_PATH = `${ROOT_PATH}smsRecords-list`;
export const ADD_SMSRECORDS_PATH = `${ROOT_PATH}add-smsRecords`;
export const EDIT_SMSRECORDS_PATH = `${ROOT_PATH}edit-smsRecords`;
// payments

export const PAYMENTS_LIST_PATH = `${ROOT_PATH}payments-list`;
export const ADD_PAYMENTS_PATH = `${ROOT_PATH}add-payments`;
export const EDIT_PAYMENTS_PATH = `${ROOT_PATH}edit-payments`;
// partner

export const PARTNER_LIST_PATH = `${ROOT_PATH}partner-list`;
export const ADD_PARTNER_PATH = `${ROOT_PATH}add-partner`;
export const EDIT_PARTNER_PATH = `${ROOT_PATH}edit-partner`;
// businessExpense

export const BUSINESSEXPENSE_LIST_PATH = `${ROOT_PATH}businessExpense-list`;
export const ADD_BUSINESSEXPENSE_PATH = `${ROOT_PATH}add-businessExpense`;
export const EDIT_BUSINESSEXPENSE_PATH = `${ROOT_PATH}edit-businessExpense`;
export const CHECK_DEVICES_PATH = `${ROOT_PATH}check-devices`;
export const DATABASE_BACKUP_PATH = `${ROOT_PATH}database-backup`;
// gymLead (marketing site enquiries)
export const GYMLEAD_LIST_PATH = `${ROOT_PATH}gym-leads`;
// paymentPackage

export const PAYMENTPACKAGE_LIST_PATH = `${ROOT_PATH}paymentPackage-list`;
export const ADD_PAYMENTPACKAGE_PATH = `${ROOT_PATH}add-paymentPackage`;
export const EDIT_PAYMENTPACKAGE_PATH = `${ROOT_PATH}edit-paymentPackage`;
// SLUGS_EXPORTS_AREA

// BioTime cleanup
export const BIOTIME_CLEANUP_PATH = `${ROOT_PATH}biotime-cleanup`;

// Payment date mismatch audit
export const PAYMENT_DATE_MISMATCH_PATH = `${ROOT_PATH}payment-date-mismatch`;

// BioTime face sync manager
export const BIOTIME_FACE_SYNC_PATH = `${ROOT_PATH}biotime-face-sync`;

// BioTime user diff (DB vs device)
export const BIOTIME_USER_DIFF_PATH = `${ROOT_PATH}biotime-user-diff`;

// BioTime server migration
export const BIOTIME_MIGRATION_PATH = `${ROOT_PATH}biotime-migration`;

// id card
export const ID_CARD_PATH = `${ROOT_PATH}generate-id-card`;
